import React, {useState} from 'react';
import {Link,Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import CopyToClipboard from 'react-copy-to-clipboard';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import LaunchIcon from '@mui/icons-material/Launch';
import MessageIcon from '@mui/icons-material/Assignment';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {Inc,Owner,Plan,NextPlan,SaleSearchCondition} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import Loading from './Loading';
import Alert from './Alert';
import Yesno from './Yesno';
import Toast from './Toast';
import PlanListSearch from './PlanListSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Title from './Title';
import AppBank from './AppBank';

interface Props {
	owner:Owner,
	bank:AppBank,	
}
let p:number = 1;
const defPlans:Plan[] = [];
const defCheckedIds:number[] = [];

const PlanList = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        plans:defPlans,
		nextPlans:[] as NextPlan[],
		checkedIds:defCheckedIds,
		allChecked:false,
        isLoading:true,
        pager:null,
		yesno:"",
		alert:"",
        cond:Inc.defaultSaleSearchCondition(),
    });
	const [toast,setToast] = useState('');
    const search = (cond:SaleSearchCondition,first?:boolean)=>{
        //console.log("search",cond);
        setStates({...states,"isLoading":true});
        if( first ){
            p = 1;
        }
        window.scrollTo(0,0);
        Ajax.search("plan/list",cond,p,(res:any)=>{
			//console.log(res);
            if( res.ok ){
                setStates({...states,plans:res.plans,nextPlans:res.next_plans,cond:cond,pager:res.pager,isLoading:false,checkedIds:defCheckedIds,allChecked:false,yesno:""});
            } else {
                setStates({...states,"isLoading":false});
            }
        });
    }
	const jump = (newPage:number)=>{
		//send(values,p);
		p = newPage;
		search(states.cond);
    }
	const checkId = (id:number)=>{
		if( states.checkedIds.includes(id) ){
			let ids = states.checkedIds;
			const index = ids.findIndex((v) => v===id);
			ids.splice(index,1);
			setStates({...states,"checkedIds":ids});
		} else {
			setStates({...states,"checkedIds":states.checkedIds.concat(id)});
		}
	}
	const checkAllId = ()=>{
		if( states.allChecked ){
			setStates({...states,"checkedIds":[],"allChecked":false});
		} else {
			let ids:number[] = [];
			for( let i=0 ; i<states.plans.length ; i++ ){
				if(states.plans[i].status==="1") {
					ids.push( states.plans[i].plan_id );
				}
			}
			setStates({...states,"checkedIds":ids,"allChecked":true});
		}
	}
	const yes = ()=>{
		if( states.yesno==="remove" ){
			Ajax.send("plan/remove",{plan_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond);
				}
			});
		}
	}
	const no = ()=>{
		setStates({...states,"yesno":""});
	}
	const alertClose = ()=>{
		setStates({...states,"alert":""});
	}
	const copy = ()=>{
		setToast('クリップボードにURLをコピーしました');
	}
	const copyPriorKey = ()=>{
		setToast('クリップボードに先行販売キーをコピーしました');
	}
	const closeToast = ()=>{
		setToast('');
	}
	const dummy = ()=>{
		
	}    
	const remove = ()=>{
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"発売日を選択して下さい"});
		} else {
			setStates({...states,"yesno":"remove"});
		}
	}

	let yesnoMes = "";
	if( states.yesno!=="" ){
		if( states.yesno==="remove" ){
			yesnoMes = "選択した発売日を削除します。\n本当によろしいですか？";
		}
	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

    return (
		<div id="plan_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="発売日一覧" icon="trending"/>
                        <div style={{marginBottom:"2em"}}>
                            あなたの商品の発売日一覧です。<br/>
                            新たに発売日を登録するには、「新規登録」をクリックして下さい。先行発売キーについては、「先行販売の利用方法」に説明があります。<br/>
                            発売日を決めないと、商品はいつまで経っても発売されませんのでご注意を。<br/>
							<Hidden mdUp implementation="js">
								<div style={{width:"100%",maxWidth:"160px",marginRight:"0",marginLeft:"auto"}}>
								<FormControl fullWidth={true} style={{margin:"1em 0"}}>
									<Link to="/plan/input"><Button variant="contained" color="primary" style={{width:"100%"}}><AddIcon/>新規登録</Button></Link>
								</FormControl>
								</div>
							</Hidden>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>
										<Checkbox
											checked={states.allChecked}
											onClick={()=>checkAllId()}
											color="primary"
											className={classes.listCheckbox}
										/>									
										
									</TableCell>

                                    <TableCell className={classes.tableHeadNowrap} align="center">抽選期間</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}>画像</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center">商品名</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableHeadNowrap} align="center">個数</TableCell>
                                        <TableCell className={classes.tableHeadNowrap} align="center">先行販売キー</TableCell>
                                        <TableCell className={classes.tableHeadNowrap} align="center">状態</TableCell>
                                    </Hidden>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {states.plans.map( (plan:any,index:number)=>{
                            const key = "plan"+index;
                            let item_status = "発売済";
                            if(plan.item_status==="2"){
                                item_status = "抽選受付中";
                            } else if(plan.item_status==="1"){
                                item_status = "抽選完了";
                            } else if(plan.item_status==="12"){
                                item_status = "近日抽選";
                            } else if(plan.item_status==="11"){
                                item_status = "近日発売";
                            }
                            let prior_key = "";
                            if( plan.prior_flag ){
                                prior_key = String(plan.plan_id) + plan.prior_key;
                            }
                            const v = states.checkedIds.includes(plan.plan_id);
                            return (
                                <TableRow key={key}>
                                    <TableCell className={classes.tableCellDense} style={{width:'2em'}}>
                                        {plan.status==="1" ? (
										<Checkbox
						checked={v}
						value={String(plan.plan_id)}
						onClick={()=>checkId(plan.plan_id)}
						color="primary"
						className={classes.listCheckbox}
										/>
                                        ):(
                                            <span></span>
                                        )}
                                    </TableCell>

                                    <TableCell className={classes.tableCellNowrap} style={{verticalAlign:"middle",width:'7em'}} align='center'>
                                        {plan.plan_date}<br/>
                                        {plan.plan_hour}:00
                                        {plan.lottery_period_label!=="" &&
                                        <span> + {plan.lottery_period_label}</span>
                                        }
                                    </TableCell>
                                    <TableCell className={classes.tableCellDense} align="center" sx={{display:{lg:'table-cell',md:'none',sm:'table-cell',xs:'none'}}}><StoreImg owner_id={props.owner.owner_id} img_id={plan.img_id} className="imgList"/></TableCell>
                                    <TableCell className={classes.tableCellDense}>
                                        <span className={classes.itemId}>ID:{plan.item_id}</span><br/>
                                        {plan.item_name}<br/>
                                        <Hidden smUp implementation="js">
                                        <div style={{marginTop:"0.5em"}}>
                                            <Divider style={{marginBottom:"0.25em"}}/>
                                            {plan.prior_flag &&
                                                <CopyToClipboard text={prior_key} onCopy={copy}><Tooltip title="先行販売キーをコピーする"><div style={{cursor:"pointer"}}>先行キー：{prior_key}<FontAwesomeIcon icon="clipboard" style={{marginLeft:"0.25em"}}/></div></Tooltip></CopyToClipboard>
                                            }
                                            {Tools.colorLabel("plan_status",plan.item_status,item_status)}
                                        </div>
                                        </Hidden>

                                    </TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableCellNowrap} align="right">{plan.su}{plan.unit}</TableCell>
                                        <TableCell className={classes.tableCellNowrap} align="center">
                                        {plan.prior_flag ? (
                                            <CopyToClipboard text={prior_key} onCopy={copyPriorKey}><Tooltip title="先行販売キーをコピーする"><div style={{cursor:"pointer"}}>{prior_key}<FontAwesomeIcon icon="clipboard" style={{marginLeft:"0.25em"}}/></div></Tooltip></CopyToClipboard>
                                        ):(
                                            <span>なし</span>
                                        )}
                                        </TableCell>
                                        <TableCell className={classes.tableCellNowrap} align="center">
                                        {Tools.colorLabel("plan_status",plan.item_status,item_status)}
                                        </TableCell>
                                    </Hidden>

                                </TableRow>
                            );
                        })}
                            </TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="登録・修正" size={2}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Link to="/plan/input"><Button variant="contained" color="primary" style={{width:"100%"}}><AddIcon/>新規登録</Button></Link>
							</FormControl>
							<Divider style={{marginBottom:"1em"}}/>
						</Hidden>
						<FormControl fullWidth={true}>
							<div className={classes.withIcon} style={{marginBottom:"0.5em"}}><CheckBoxIcon/>チェックした発売日を</div>
							<Button variant="contained" color="secondary" size="small" onClick={remove} disabled={states.checkedIds.length===0}><DeleteForeverIcon/>削除する</Button>
						</FormControl>
                        <ul className={classes.guideUl}>
                            <li className={classes.guideLi}>発売日を削除すると商品は「在庫なし」の状態表示になります。</li>
                        </ul>
						<div style={{textAlign:'right'}}>
							<Link to="/help/lottery/39"><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>抽選販売とは</Button></Link>
							<Link to="/help/sale/127"><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>状態表示とは</Button></Link>
						</div>
					</Paper>

					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="発売予定とURL" size={2}/>
						{states.nextPlans.length===0 &&
							<div style={{color:'#666666'}}>
								発売日の予定はありません
							</div>
						}
						{states.nextPlans.map((plan:NextPlan,index:number)=>{
							const key = "url"+index;
							const date = plan.plan_date.replace(/-/g, '');
							const url = 'https://store.retro-biz.com/list_d'+date+'_'+props.owner.owner_id+'_'+plan.plan_hour+'.html';
							return (
							<div key={key} style={{marginBottom:'1em'}}>
								<div><span style={{fontSize:'110%',fontWeight:'bold'}}>{plan.plan_date.replace(/-/g, '/')}</span><span style={{fontSize:'100%',fontWeight:'bold',marginLeft:'1em'}}>{plan.plan_hour}:00</span></div>
								<div style={{lineHeight:"1.0em",textAlign:"left"}}>
									<input type="text" value={url} style={{width:'100%',fontSize:'75%',padding:'0.25em 0.1em',boxSizing:'border-box'}} onChange={dummy}/>
								</div>
								<div style={{textAlign:"left",marginLeft:'-0.75em'}}>
									<a href={url} rel="noopener noreferrer" target="_blank"><Button variant="text" color="primary"><LaunchIcon/> 発売日ページを開く</Button></a>
									<CopyToClipboard text={url} onCopy={copy}>
										<Button variant="text" color="primary" size="small"><MessageIcon/> URLをコピー</Button>
									</CopyToClipboard>
								</div>
							</div>
							)
						})}
					</Paper>

                    <Paper className={classes.paper}>
                        <PlanListSearch update={search} bank={props.bank} bankKey={"savedPlanListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
			<Yesno mes={yesnoMes} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Alert mes={states.alert} close={alertClose} isOpen={states.alert!==""}/>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default PlanList;
